import { AppEnum, DateFormatHelper, LeaseEnums, OptionHelper, RecordMap } from "@/Shared";
import { LeaseModel } from "../LeaseModel";
import { LeaseFormValues } from "../LeaseFormValidation";
import { TransactionModel } from "@/Domains/Transaction";
import { ContactModel } from "@/Domains/Contact";

export class LeaseFormViewModel {
    public id : number;

    public constructor(
        private viewEnums: LeaseEnums,
        private _contactMap: RecordMap<ContactModel>,
        private _transactionMap: RecordMap<TransactionModel>,
        private lease?: LeaseModel) {
            this.id = this.lease?.id ?? 0;
    }

    get formValues(): LeaseFormValues {
        return {
            leaseType: this.lease?.leaseType,
            leaseStart: DateFormatHelper.toInput(this.lease?.leaseStart),
            leaseEnd: DateFormatHelper.toInput(this.lease?.leaseEnd),

            revisionRate: this.lease?.revisionRate,
            revisionFrequency: this.lease?.revisionFrequency,

            activity: this.lease?.activity,
            usageDescription: this.lease?.usageDescription,

            leaseOptions : this.lease?.leaseOptions ?? [],

            tenants: this.lease?.tenants?.map(leaseTenant => leaseTenant.tenantId) ?? [],
            transactionId: this.lease?.transactionId ?? null,
        };
    }

     get title() {
        return this.lease ? 
             "Bail N° " + this.id + " - " + this.lease?.leaseType?.toUpperCase() :
            "Création de bail";
    }

    get transactionOptions() {
        return [{ key: "", value: "", label: "Choisir une transaction" }, ...OptionHelper.transactionOptions(this._transactionMap.toArray())]
    }

    get leaseTypeOptions() {
        return [{ key: "", value: "", label: "Choisir un type de contrat" }, ...this.viewEnums.LeaseTypeEnum];
    }

    getLeaseOptions = () : AppEnum[] => {
		return OptionHelper.sortByLabel(this.viewEnums.LeaseOptionEnum);
	}

    get tenantsOptions() : AppEnum[] {
		return [{ key: "", value: "", label: "Choisir un type de contrat" }, ...OptionHelper.contactOptions(this._contactMap.toArray())];
	}
}
